"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _paywallTheme = require("../../services/paywall-theme");

var _paywallBanner = _interopRequireDefault(require("./paywall-banner.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getTheme = function getTheme() {
  return {
    headerThree: _paywallBanner["default"].title,
    text: _paywallBanner["default"].text,
    button_container: _paywallBanner["default"].button
  };
};

var none = function none() {
  return {};
};

var PaywallBanner = function PaywallBanner(_ref) {
  var appSettings = _ref.appSettings,
      section = _ref.section,
      RichContentViewer = _ref.viewer,
      banner = _ref.banner,
      onSubscribe = _ref.onSubscribe,
      className = _ref.className;
  var bannerStyle = (0, _paywallTheme.getBannerStyle)({
    appSettings: appSettings,
    section: section
  });
  var design = (0, _lodash.get)(banner, 'entityMap[0].data.button.design');

  if ((0, _lodash.isObject)(design)) {
    design.background = bannerStyle['--paywall-button-color'];
    design.color = bannerStyle['--paywall-button-text-color'];
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_paywallBanner["default"].container, className),
    style: bannerStyle
  }, /*#__PURE__*/_react["default"].createElement(RichContentViewer, {
    initialRawState: banner,
    getTheme: getTheme,
    getStyle: none,
    onButtonClick: onSubscribe
  }));
};

var _default = PaywallBanner;
exports["default"] = _default;